import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgSelectConfig, NgSelectModule } from "@ng-select/ng-select";
import { OAuthService } from "angular-oauth2-oidc";
import { ModalComponent } from "components/modal/modal.component";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { DefaultResponse } from "src/app/shared/models/DefaultResponse";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { Atribuicao, AtribuicaoLoginSed, PerfilLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { PerfilService } from "src/app/shared/services/perfil.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { AtribuicoesPorUsuario } from '../../../client/src/app/shared/models/sed/UserLogin';
import { authConfigMasp } from "src/app/shared/auth/models/auth-masp.config";

@Component({
  selector: 'modal-alterar-perfil',
  templateUrl: './modal-alterar-perfil.component.html',
  styleUrls: ['./modal-alterar-perfil.component.scss'],
  standalone: true,
  imports: [ModalComponent, CommonModule, NgxSpinnerModule, NgSelectModule, ReactiveFormsModule]
})
export class ModalAlterarPerfil implements OnInit {
  //Injeções
  private spinnerService = inject(NgxSpinnerService);
  private config = inject(NgSelectConfig);
  private oauthService = inject(OAuthService);
  private authService = inject(AuthService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  private toastrService = inject(ToastrService);
  private router = inject(Router);
  private perfilService = inject(PerfilService);
  private escolaService = inject(EscolaService);
  private psicologoService = inject(PsicologoService)

  public usuario: UserLoginSed;
  public usuarioLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;
  public urlAtual: string = "";

  constructor() {
    this.config.notFoundText = 'Não encontrado';
    this.usuarioLogado = this.authService.getUser();

    if (this.usuarioLogado != null && !this.usuarioLogado.flPsicologo) {
      this.atribuicoesLogin = this.usuarioLogado?.DadosUsuario[0];
    }
  }

  public showModalAlterarPerfil: boolean;
  public showModalEscola: boolean;
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public formModalEscola!: FormGroup;
  public resultPesquisa: boolean = false;
  public diretoriasCivicoMilitar: Diretoria[] = [];
  public get form() { return this.formModalEscola.controls; }
  public atribuicoes: AtribuicoesPorUsuario;

  public ngOnInit() {

    this.formModalEscola = new FormGroup({
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null, [Validators.required])
    });

    this.getDiretoriaCivicoMilitar();

  }

  public closeModal() {
    this.showModalAlterarPerfil = false;
  }
  public closeModalEscola() {
    this.showModalEscola = false;
  }

  public async OpenModalChangePerfil() {
    if (this.usuarioLogado) {
      this.spinnerService.show();
      this.usuario = this.usuarioLogado;
      await this.getAtribuicoes();

      this.spinnerService.hide();
    }
  }

  public async getAtribuicoes() {
    this.spinnerService.show();
    var response = await lastValueFrom(this.perfilService.getPerfisUsuario(this.usuario.perfis));
    this.usuario.perfis = response.data;

    if (this.usuario?.perfis?.length == 0) {

      this.toastrService.error('Este login não está autorizado a acessar o CONVIVA. Não tem Perfis na SED.', 'CONVIVA');
      this.toastrService.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');

      setTimeout(async () => {
        if (this.authService.hasTokenGovBr()) {
          await this.oauthService.loadDiscoveryDocument();
        } else {
          this.oauthService.configure(authConfigMasp);
        }

        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageMasp();
        this.authService.cleanStorageConviva();
        this.oauthService.logOut();
        return;
      }, 6000);
    }

    if (this.usuario?.perfis?.length > 1) {
      this.showModalAlterarPerfil = true;
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();
  }

  public async onClickPerfil(cdUsuario: number, codigoPerfil: number, codigoComportamento: number) {
    this.usuarioLogado!.codigoDiretoria = undefined;
    this.usuarioLogado!.codigoEscola = undefined;
    this.usuarioLogado!.codigoPolo = 0;
    this.diretorias = [];
    this.escolas = [];
    this.form.codigoDiretoria.reset();
    this.form.codigoEscola.reset();
    this.form.codigoDiretoria.enable();
    this.form.codigoEscola.enable();

    this.spinnerService.show();
    var response = await lastValueFrom(this.authService.getAtribuicoesPerfil(cdUsuario, codigoPerfil));
    this.atribuicoes = response;

    if (response.statusCode == 401) {
      this.toastrService.error('Este login não está autorizado a acessar o CONVIVA.', 'CONVIVA');
      this.toastrService.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');
      this.spinnerService.hide();
      this.authService.cleanStorageGovBr();
      this.authService.cleanStorageMasp();
      this.authService.cleanStorageConviva();
      await this.oauthService.loadDiscoveryDocument();
      this.oauthService.logOut();
      return;
    }

    if (response.statusCode == 200) {
      const perfilSelecionado = this.usuario.perfis.find((item: PerfilLoginSed) => item.codigoPerfil == codigoPerfil);

      if (codigoPerfil == Perfil.Psicólogo) {
        if (response.DadosUsuario?.length > 0) {
          await this.setDadosPerfilPsicologo(perfilSelecionado!, response.DadosUsuario);
        }
        await this.getLoginPsicologo();
        return;
      }

      this.setPerfil(codigoPerfil);
      this.usuarioLogado!.flPsicologo = false;
      await this.setDadosPerfilUnico(response.DadosUsuario);
      await this.getDiretorias();

      if (codigoPerfil == Perfil.PEC) {
        await this.getFuncionalidadesPEC(codigoPerfil);
      } else {
        this.getFuncionalidades(codigoPerfil);
      }

      if (codigoPerfil == Perfil.CoordenadorPsicologo) {
        const coordenadorPsicologo = await lastValueFrom(this.psicologoService.getPsicologoPorCPF(this.usuario.cpf))
          .catch(() => null);
        if (coordenadorPsicologo?.data) {
          this.usuarioLogado!.autorizacaoUsoDados = coordenadorPsicologo.data.autorizacaoDados;
        }
      }
      return;
    }

    if (response.statusCode == 201) {
      const perfilSelecionado = this.usuario.perfis.find((item: PerfilLoginSed) => item.codigoPerfil == codigoPerfil);

      if (codigoPerfil == Perfil.Psicólogo) {
        if (response.DadosUsuario?.length > 0) {
          await this.setDadosPerfilPsicologo(perfilSelecionado!, response.DadosUsuario);
        }
        await this.getLoginPsicologo();
        return;
      }

      this.setPerfil(codigoPerfil);
      this.usuarioLogado!.flPsicologo = false;
      this.getDiretoriasCombo();
      this.getFuncionalidades(codigoPerfil);
    }
  }

  public getFuncionalidades(codigoPerfil: number) {

    this.perfilService.getFuncionalidadesPerfil(codigoPerfil).subscribe({
      next: async (response: DefaultResponse) => {
        await this.setLoginAnalytics();

        this.usuarioLogado!.funcionalidades = response.data;
        this.authService.setUser(this.usuarioLogado!);
        this.spinnerService.hide();
        this.showModalAlterarPerfil = false;
        this.showModalEscola = true;
        if (this.form.codigoDiretoria.value && this.escolas.length === 0) {
          this.getEscolas();
        }
      },
      error: (error) => {
        this.ConvivaErrors.handleError(error);
        this.spinnerService.hide();
      }
    });
  }

  public async setLoginAnalytics() {
    await lastValueFrom(this.authService.setLoginAnalytics(
      this.usuarioLogado!.codigoUsuario,
      this.usuarioLogado!.nome,
      this.usuarioLogado!.cpf,
      this.usuarioLogado!.codigoPerfil,
      this.usuarioLogado!.nomePerfil,
      this.usuarioLogado!.NumeroComportamento
    ));
  }

  public getDiretoriasCombo() {
    this.spinnerService.show();

    this.escolaService
      .getDiretoriaPorTipoDiretoria()
      .subscribe({
        next: (response: DefaultResponse) => {
          if (!response.isSucess) {
            this.toastrService.error(response.message);
          }
          this.diretorias = response.data;
          this.spinnerService.hide();
        },
        error: (error) => {
          this.ConvivaErrors.handleError(error);
          this.spinnerService.hide();
        },
      });
  }

  public async getDiretorias() {
    this.diretorias = [];
    this.escolas = [];
    const diretoriasAdicionadas = new Set<number>();
    this.usuarioLogado?.DadosUsuario?.forEach((item: AtribuicaoLoginSed) => {

      let diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      const incluirDiretoria = this.usuarioLogado?.codigoDiretoria != undefined && this.usuarioLogado.codigoEscola != undefined
        ? this.usuarioLogado?.codigoDiretoria == diretoria.codigoDiretoria
        : true;
      if (incluirDiretoria && !diretoriasAdicionadas.has(diretoria.codigoDiretoria)) {
        diretoriasAdicionadas.add(diretoria.codigoDiretoria);
        this.diretorias.push(diretoria);
      }

      if (item.CodigoEscola && item.NomeEscola) {
        let escola = new Escola();
        escola.codigoEscola = item.CodigoEscola;
        escola.nomeEscola = item.NomeEscola;
        escola.codigoDiretoria = item.CodigoDiretoria;
        if (this.usuarioLogado?.codigoDiretoria != undefined && this.usuarioLogado.codigoEscola != undefined) {
          if (this.usuarioLogado?.codigoDiretoria == diretoria.codigoDiretoria)
            this.escolas.push(escola);
        }
        else
          this.escolas.push(escola);
      }

    });



    if (this.diretorias.length == 1 && this.escolas.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();

      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      this.form.codigoEscola.disable();
    }

    if (this.diretorias.length == 1 && this.escolas.length > 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    }

    if (this.diretorias.length == 1 && this.escolas.length == 0) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      await this.getEscolas();
    }

  }

  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];

    this.usuarioLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      let diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);
    });

    if (this.diretorias.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();

      this.getEscolas();
    }
  }

  public getDiretoriasPerfilEscola(atribuicoes: AtribuicaoLoginSed[], codigoPerfil: number) {
    this.diretorias = [];
    this.escolas = [];
    let _diretorias = [];

    if(codigoPerfil == Perfil.Monitor){

      const dadosUsuario = atribuicoes || [];

      const diretoriasApi = new Set(this.diretoriasCivicoMilitar.map((x: any) => x.codigoDiretoria));
      _diretorias = dadosUsuario.filter(item => diretoriasApi.has(item.CodigoDiretoria));

      for (const item of _diretorias) {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria.trim();
        this.diretorias.push(diretoria);
      }

    }
    else {

      atribuicoes?.map((item: AtribuicaoLoginSed) => {
        let diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        this.diretorias.push(diretoria);

      });

    }

    if (this.diretorias.length == 1 && this.escolas.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      this.form.codigoEscola.disable();
    }
    if (this.diretorias.length == 1 && this.escolas.length > 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    }
  }

  public getEscolas() {

    const codigoDE = this.formModalEscola.get('codigoDiretoria');
    if (codigoDE?.value) {
      if (this.usuarioLogado!.DadosUsuario[0]?.CodigoPerfil == Perfil.Psicólogo) {
        this.spinnerService.show();

        this.escolaService
          .getEscolasPorCodigoDiretoria(codigoDE.value)
          .subscribe({
            next: (response: DefaultResponse) => {
              if (!response.isSucess) {
                this.toastrService.error(response.message);
                this.escolas = [];
                this.form.codigoEscola.setValue(null);
                this.form.codigoEscola.disable();
                this.spinnerService.hide();
                return;
              }

              this.escolas = response.data;
              this.selecionarEscolaLoginSeDisponivel();
              this.escolas.length === 1
                ? this.form.codigoEscola.disable()
                : this.form.codigoEscola.enable();
              this.spinnerService.hide();
            },
            error: (error) => {
              this.ConvivaErrors.handleError(error);
              this.spinnerService.hide();
            },
          });
      } else if (this.usuarioLogado!.DadosUsuario[0]?.NumeroComportamento == 1 ||
        this.usuarioLogado!.DadosUsuario[0]?.NumeroComportamento == 2) {
        //this.zerarEscola();
        if (codigoDE?.value != null) {
          this.spinnerService.show();

            this.escolaService
              .getEscolasPorCodigoDiretoria(codigoDE?.value)
              .subscribe({
                next: (response: DefaultResponse) => {
                  if (!response.isSucess) {
                    this.toastrService.error(response.message);
                  }
                  this.escolas = response.data;
                  this.spinnerService.hide();
                },
                error: (error) => {
                  this.ConvivaErrors.handleError(error);
                  this.spinnerService.hide();
                },
              });
        }
      } else if (this.usuarioLogado!.DadosUsuario[0]?.NumeroComportamento == 3 ||
        this.usuarioLogado!.DadosUsuario[0]?.NumeroComportamento == 4) {

        this.escolas = [];
        let escolasAux = [];

        if(this.usuarioLogado!.DadosUsuario[0].CodigoPerfil == Perfil.Monitor){

            this.escolaService
              .getEscolasCivicoMilitar(codigoDE?.value)
              .subscribe({
                next: (response: DefaultResponse) => {
                  if (!response.isSucess) {
                    this.toastrService.error(response.message);
                  }

                  let _escolas = [];
                  const dadosUsuario = this.usuarioLogado?.DadosUsuario || [];

                  const escolasApi = new Set(response.data.map((x: any) => x.codigoEscola));
                  _escolas = dadosUsuario.filter(item => escolasApi.has(item.CodigoEscola));

                  for (const item of _escolas) {

                    let escola: Escola = {
                      codigoEscola: item.CodigoEscola,
                      nomeEscola: item.NomeEscola,
                      codigoDiretoria: item.CodigoDiretoria
                    } as Escola;

                    escolasAux.push(escola);
                  }

                  if(escolasAux.length > 0){
                    this.escolas = escolasAux;
                  }

                  this.spinnerService.hide();
                },
                error: (error) => {
                  this.ConvivaErrors.handleError(error);
                  this.spinnerService.hide();
                },
              });

          } else {

            this.usuarioLogado!.DadosUsuario
              .filter(x =>
                x.CodigoEscola &&
                x.NomeEscola &&
                x.CodigoDiretoria == this.form.codigoDiretoria.value)
              .forEach((item: AtribuicaoLoginSed) => {
                let escola = new Escola();
                escola.codigoEscola = item.CodigoEscola;
                escola.nomeEscola = item.NomeEscola;
                escola.codigoDiretoria = item.CodigoDiretoria;
                this.escolas.push(escola);

              });

          }

        if (this.escolas.length == 1) {
          this.form.codigoEscola.setValue(this.escolas[0].codigoEscola)
        }
      }
    } else {
      this.form.codigoEscola.setValue(null);
      this.escolas = [];

    }

  }

  private selecionarEscolaLoginSeDisponivel(): void {
    const codigoEscolaSelecionado = this.usuarioLogado?.codigoEscola ?? this.form.codigoEscola.value;

    if (codigoEscolaSelecionado) {
      const escolaSelecionadaExiste = this.escolas
        .some((e) => Number(e.codigoEscola) === Number(codigoEscolaSelecionado));

      if (escolaSelecionadaExiste) {
        this.form.codigoEscola.setValue(Number(codigoEscolaSelecionado));
        return;
      }
    }

    if (this.escolas.length === 1) {
      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      return;
    }

    this.form.codigoEscola.setValue(null);
  }

  public SelecionarEscola() {

    if (this.formModalEscola.invalid) {
      this.toastrService.error('Favor de preencher a Diretoria e a Escola.', 'CONVIVA');
      return;
    }

    this.usuarioLogado!.codigoDiretoria = this.formModalEscola.get('codigoDiretoria')?.value == null ? 0 : this.formModalEscola.get('codigoDiretoria')?.value;
    this.usuarioLogado!.codigoEscola = this.formModalEscola.get('codigoEscola')?.value == null ? 0 : this.formModalEscola.get('codigoEscola')?.value;

    if (this.usuarioLogado!.codigoPerfil == Perfil.CoordenadorPsicologo) {
      this.usuarioLogado!.codigoPolo = this.usuarioLogado!.DadosUsuario.find(
        (item) => item.CodigoDiretoria == this.usuarioLogado!.codigoDiretoria
      )?.CodigoPolo ?? 0;
    }

    this.authService.setUser(this.usuarioLogado!);
    this.showModalEscola = false;

    this.urlAtual = this.router.url;
    if(this.urlAtual == '/home-pec'){
      this.router.navigate(['/']);
    }
    else{
      window.location.reload();
    }
  }



  public async setDadosPerfilUnico(atribuicoes: Atribuicao[]) {
    var novosDadosUsuarios: AtribuicaoLoginSed[] = [];
    var dadosUsuario = this.usuarioLogado!.DadosUsuario[0];

    for (let item of atribuicoes) {
      let polo = await lastValueFrom(this.psicologoService.getPolos(item.CodigoDiretoria))
        .catch(err => this.ConvivaErrors.handleResultError(err))

      let newAtribuicao = new AtribuicaoLoginSed();
      //Dados atribuições
      newAtribuicao.CodigoDiretoria = item.CodigoDiretoria;
      newAtribuicao.NomeDiretoria = item.NomeDiretoria;
      newAtribuicao.CodigoTurma = item.CodigoTurma;
      newAtribuicao.NomeEscola = item.NomeEscola;
      newAtribuicao.CodigoEscola = item.CodigoEscola;
      newAtribuicao.CodigoPolo = polo?.data?.[0]?.codigoPolo ?? 0;
      //Dados cabeçalho
      newAtribuicao.NumeroComportamento = dadosUsuario.NumeroComportamento;
      newAtribuicao.Comportamento = dadosUsuario.Comportamento;
      newAtribuicao.CodigoPerfil = dadosUsuario.CodigoPerfil;
      newAtribuicao.NomePerfil = dadosUsuario.NomePerfil;
      newAtribuicao.Cpf = dadosUsuario.Cpf;
      newAtribuicao.Email = dadosUsuario.Email;
      newAtribuicao.Login = dadosUsuario.Login;
      newAtribuicao.CodigoUsuario = dadosUsuario.CodigoUsuario;
      newAtribuicao.DataInclusao = dadosUsuario.DataInclusao;
      newAtribuicao.Nome = dadosUsuario.Nome;

      novosDadosUsuarios.push(newAtribuicao);
    }

    this.usuarioLogado!.DadosUsuario = novosDadosUsuarios;
  }

  public async getLoginPsicologo() {

    var response = await lastValueFrom(this.psicologoService.getPsicologoPorCPF(this.usuario.cpf));
    if (!response.isSucess) {
      this.toastrService.error(response.message);

      setTimeout(async () => {
        if (this.authService.hasTokenGovBr()) {
          await this.oauthService.loadDiscoveryDocument();
        } else {
          this.oauthService.configure(authConfigMasp);
        }
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageMasp();
        this.authService.cleanStorageConviva();
        this.oauthService.logOut();
        this.spinnerService.hide();
      }, 3000);

      return;
    }

    if (response.data == null) {
      this.toastrService.error("Psicólogo sem acesso ao Conviva.");

      setTimeout(async () => {
        await this.oauthService.loadDiscoveryDocument();
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageConviva();
        this.authService.cleanStorageMasp();
        this.oauthService.logOut();
        this.spinnerService.hide();
      }, 3000);

      return;
    }
    this.PopulaPsicologo(response.data);
    await this.carregarAtribuicoesSedPsicologo(this.usuarioLogado!.cpf);
    await this.getFuncionalidade(Perfil.Psicólogo);
    await this.getDiretoriasPorPolo(this.usuarioLogado!.codigoPolo);
    if (this.form.codigoDiretoria.value) {
      this.getEscolas();
    }
    this.MostraModalEscola();
    this.authService.setUser(this.usuarioLogado!);
    this.spinnerService.hide();

  }

  private async carregarAtribuicoesSedPsicologo(cpf: string) {
    const response = await lastValueFrom(this.psicologoService.getPsicologoAtribuicoesPorCpf(cpf))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess || !response.data) {
      return;
    }

    const escolas = response.data.escolas ?? response.data.Escolas ?? [];
    if (!escolas.length) {
      return;
    }

    const perfilSelecionado = this.usuario.perfis.find((p) => p.codigoPerfil === Perfil.Psicólogo)
      ?? this.usuario.perfis[0];
    const atribuicoes = escolas.map((item: any) => ({
      CodigoDiretoria: item.codigoDiretoria ?? item.CodigoDiretoria,
      NomeDiretoria: item.nomeDiretoria ?? item.NomeDiretoria,
      CodigoEscola: item.codigoEscola ?? item.CodigoEscola,
      NomeEscola: item.nomeEscola ?? item.NomeEscola,
      CodigoTurma: 0,
      NomeTurma: ''
    }));

    await this.setDadosPerfilPsicologo(perfilSelecionado, atribuicoes as Atribuicao[]);
  }

  private async setDadosPerfilPsicologo(perfilSelecionado: PerfilLoginSed, atribuicoes: Atribuicao[]) {
    const novosDadosUsuarios: AtribuicaoLoginSed[] = [];
    const dadosUsuario = this.usuarioLogado!.DadosUsuario[0];

    for (const item of atribuicoes) {
      const polo = await lastValueFrom(this.psicologoService.getPolos(item.CodigoDiretoria))
        .catch(err => this.ConvivaErrors.handleResultError(err));

      const newAtribuicao = new AtribuicaoLoginSed();
      newAtribuicao.CodigoDiretoria = item.CodigoDiretoria;
      newAtribuicao.NomeDiretoria = item.NomeDiretoria;
      newAtribuicao.CodigoTurma = item.CodigoTurma;
      newAtribuicao.NomeEscola = item.NomeEscola;
      newAtribuicao.CodigoEscola = item.CodigoEscola;
      newAtribuicao.CodigoPolo = polo?.data?.[0]?.codigoPolo ?? 0;
      newAtribuicao.NumeroComportamento = 3;
      newAtribuicao.Comportamento = 'Escola';
      newAtribuicao.CodigoPerfil = Perfil.Psicólogo;
      newAtribuicao.NomePerfil = perfilSelecionado.descricaoPerfil;
      newAtribuicao.Cpf = dadosUsuario.Cpf;
      newAtribuicao.Email = dadosUsuario.Email;
      newAtribuicao.Login = dadosUsuario.Login;
      newAtribuicao.CodigoUsuario = dadosUsuario.CodigoUsuario;
      newAtribuicao.DataInclusao = dadosUsuario.DataInclusao;
      newAtribuicao.Nome = dadosUsuario.Nome;

      novosDadosUsuarios.push(newAtribuicao);
    }

    this.usuarioLogado!.DadosUsuario = novosDadosUsuarios;
    this.usuarioLogado!.nomePerfil = perfilSelecionado.descricaoPerfil;
    this.usuarioLogado!.codigoPerfil = perfilSelecionado.codigoPerfil;
    this.usuarioLogado!.NumeroComportamento = '3';
    this.usuarioLogado!.comportamento = 'Escola';
    this.usuarioLogado!.cpf = String(dadosUsuario.Cpf);
  }

  private MostraModalEscola() {
    this.showModalAlterarPerfil = false;
    this.showModalEscola = true;
  }

  private PopulaPsicologo(userData: any) {

    this.usuarioLogado!.flPsicologo = true;
    this.usuarioLogado!.codigoPolo = userData.codigoPoloRegional;
    this.usuarioLogado!.NumeroComportamento = '3';
    this.usuarioLogado!.comportamento = 'Escola';
    this.usuarioLogado!.nomePerfil = 'Psicólogo';
    this.usuarioLogado!.codigoPerfil = Perfil.Psicólogo;

    var atribuicao = this.usuarioLogado!.DadosUsuario[0];
    atribuicao.CodigoPolo = userData.codigoPoloRegional;
    atribuicao.NumeroComportamento = 3;
    atribuicao.Comportamento = 'Escola';
    atribuicao.CodigoPerfil = Perfil.Psicólogo;
    this.usuarioLogado!.DadosUsuario = [atribuicao];
  }

  public async getFuncionalidade(codigoPerfil: number) {
    var response = await lastValueFrom(this.perfilService.getFuncionalidadesPerfil(codigoPerfil));
    if (!response.isSucess) {
      this.toastrService.error(response.message);
      return;
    }
    this.usuarioLogado!.funcionalidades = response.data;

  }

  private async getDiretoriasPorPolo(codigoPolo: number) {
    var response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPolo));
    if (!response.isSucess) {
      this.toastrService.error(response.message)

      setTimeout(() => {
        this.router.navigate(['/login']);
        this.spinnerService.hide();
      }, 5000);
      return;
    }

    const diretoriasPolo = response.data ?? [];
    const codigosAtribuidos = new Set(
      (this.usuarioLogado?.DadosUsuario ?? [])
        .filter((d) => Number(d.CodigoPolo) === Number(codigoPolo) && d.CodigoDiretoria > 0)
        .map((d) => d.CodigoDiretoria)
    );

    this.diretorias = codigosAtribuidos.size > 0
      ? diretoriasPolo.filter((d: any) => codigosAtribuidos.has(d.codigoDiretoria))
      : diretoriasPolo.filter((d: any) =>
          (this.usuarioLogado?.DadosUsuario ?? []).some((a) => a.CodigoDiretoria === d.codigoDiretoria)
        );

    if (this.diretorias.length === 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    } else if (this.diretorias.length > 1) {
      this.form.codigoDiretoria.enable();
    } else {
      this.form.codigoDiretoria.disable();
    }
  }
  private setPerfil(cdPerfil: number) {
    var perfilSelecionado = this.usuario.perfis.find((item: PerfilLoginSed) => item.codigoPerfil == cdPerfil)
    this.usuarioLogado!.flPsicologo = cdPerfil === Perfil.Psicólogo;
    this.usuarioLogado!.DadosUsuario[0].NumeroComportamento = perfilSelecionado!.codigoComportamento;
    this.usuarioLogado!.DadosUsuario[0].NomePerfil = perfilSelecionado!.descricaoPerfil;
    this.usuarioLogado!.DadosUsuario[0].CodigoPerfil = perfilSelecionado!.codigoPerfil;
    this.usuarioLogado!.DadosUsuario[0].Comportamento = perfilSelecionado!.descricaoComportamento;
    this.usuarioLogado!.nomePerfil = perfilSelecionado!.descricaoPerfil;
    this.usuarioLogado!.codigoPerfil = perfilSelecionado!.codigoPerfil;
    this.usuarioLogado!.NumeroComportamento = perfilSelecionado!.codigoComportamento.toString();
    // this.usuarioLogado!.cpf = String(this.usuarioLogado!.DadosUsuario[0]!.Cpf);
  }

  public async getFuncionalidadesPEC(codigoPerfil: number) {

    this.perfilService.getFuncionalidadesPerfil(codigoPerfil).subscribe({
      next: async (response: DefaultResponse) => {
        this.usuarioLogado!.funcionalidades = response.data;
        this.spinnerService.hide();
        this.showModalAlterarPerfil = false;
        this.showModalEscola = false;
        if (this.usuarioLogado!.DadosUsuario[0]?.NumeroComportamento == 3 || this.usuarioLogado!.DadosUsuario[0]?.NumeroComportamento == 4)
          this.getDiretoriasPerfilEscola(this.usuarioLogado!.DadosUsuario, this.usuarioLogado!.codigoPerfil);

        // if (this.formModalEscola.invalid) {
        //   this.toastrService.error('Favor de preencher a Diretoria e a Escola.', 'CONVIVA');
        //   return;
        // }

        this.usuarioLogado!.codigoDiretoria = this.atribuicoes.DadosUsuario.length == 1 ? this.atribuicoes.DadosUsuario[0].CodigoDiretoria : 0;
        this.usuarioLogado!.codigoEscola = 0;
        this.authService.setUser(this.usuarioLogado!);
        this.showModalEscola = false;

        this.urlAtual = this.router.url;
        if(this.urlAtual == '/'){
          this.router.navigate(['/home-pec']);
        }
        else{
          window.location.reload();
        }

      },
      error: (error) => {
        this.ConvivaErrors.handleError(error);
        this.spinnerService.hide();
      }
    });
  }

  public async getDiretoriaCivicoMilitar() {
      const response = await lastValueFrom(this.escolaService.getDiretoriasCivicoMilitar())
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!response.isSucess) {
        this.toastrService.error(response.message, "Erro!");
        return;
      }

      this.diretoriasCivicoMilitar = response.data;
  }

}
